module.exports = require("ramda/src/split");